import React, { type ReactElement } from 'react'
import { Link } from 'react-router-dom'
import { Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import backgroundFooter from 'assets/landing_footer.svg'
import backgroundHeader from 'assets/landing_header.svg'
import { ReactComponent as CDTLogoIcon } from 'assets/landing_logo.svg'
import ThemeButton from 'common/ui/theme-button'
import theme from 'common/utils/theme'

import styles from './LandingPage.module.scss'

const LandingPage: React.FC = (): ReactElement => {
  const { palette } = useTheme()

  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url(${backgroundHeader})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top left',
        backgroundColor: theme.palette.blue700.main,
      }}
    >
      <div
        className={styles.footerOverlay}
        style={{
          backgroundImage: `url(${backgroundFooter})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'bottom',
        }}
      />{' '}
      <div className={styles.textContainer}>
        <div className={styles.title}>
          <Typography variant="title11" sx={{ fontSize: '40px' }}>
            Centar za digitalnu transformaciju
          </Typography>
          <CDTLogoIcon />
        </div>
        <div className={styles.text}>
          <Typography variant="title5">
            Imamo jedinstvenu priliku za vašu kompaniju! Pozivamo vas da postanete deo naše BESPLATNE mreže
            veriﬁkovanih pružalaca IT usluga unutar Centra za digitalnu transformaciju (CDT). Pridruživanjem
            ovoj mreži, vaša kompanija će otvoriti novi kanal prodaje, postavljajući vaše proizvode i usluge
            pred kompanije koje imaju konkretne potrebe za digitalnim rešenjima.
          </Typography>
          <Typography variant="title1">Šta nudimo:</Typography>
          <ul>
            <Typography variant="title5">
              <li>
                Ponude za implementaciju: CDT kroz svoje programe podrške ima najmanje 200 zahteva za
                implementaciju softverskih rešenja, hardvera ili usluga godišnje od ﬁrmi koje su deo CDT
                programa.
              </li>
            </Typography>
            <Typography variant="title5">
              <li>
                Pristup CDT ekosistemu: Ekskluzivne informacije i izveštaji o trendovima u digitalnoj
                transformaciji, kao i pristup CDT analizama rešenja.
              </li>
            </Typography>
            <Typography variant="title5">
              <li>
                Transparentnost i vidljivost: Promovisanje vaših proizvoda i usluga u okviru CDT programa i
                radionica. Transparentnost u procesu izbora ponuđača i vidljivost pred potencijalnim
                klijentima iz inostranstva, čak i za kompanije koje nisu deo CDT programa.
              </li>
            </Typography>
            <Typography variant="title5">
              <li>Strateška partnerstva: Prilike za saradnju sa liderima u tehnologiji i inovacijama.</li>
            </Typography>
          </ul>
          <Typography variant="title5">
            <strong>Napomena:</strong> Nakon uspešne verifikacije vaše kompanije od strane CDT-a, ukoliko
            želite da registrujete vašu kompaniju za pružanje usluga iz oblasti AI potrebno je da na svom
            profilu izaberete opciju &quot;Zatraži AI verifikaciju&quot; u sekciji &quot;Spremnost za
            AI&quot;.
          </Typography>
          <Typography variant="title5">
            Za programe CDT-a je do sada apliciralo preko 3.500 kompanija, a čak 800 je implementiralo
            digitalna rešenja.
          </Typography>
          <Typography variant="title5">
            Saznajte više o tome kako možete biti deo ovog ekosistema već danas preko linka{' '}
            <a
              href="http://www.cdt.org.rs"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: palette.green.main, fontWeight: 600 }}
            >
              www.cdt.org.rs
            </a>{' '}
          </Typography>
          <Typography variant="title5">
            Radujemo se budućoj saradnji i kreiranju digitalne sutrašnjice zajedno sa vama.
          </Typography>
        </div>
      </div>
      <div className={styles.buttons}>
        <Link to="/registracija">
          <ThemeButton
            sx={{
              backgroundColor: palette.blue200.main,
              '&:hover': {
                backgroundColor: palette.blue200.main,
              },
            }}
          >
            REGISTRUJ SE
          </ThemeButton>
        </Link>
        <Link to="/auth/login">
          <ThemeButton
            sx={{
              backgroundColor: palette.blue.main,
              '&:hover': {
                backgroundColor: palette.blue.main,
              },
            }}
          >
            PRIJAVI SE
          </ThemeButton>
        </Link>
      </div>
    </div>
  )
}

export default LandingPage
